import type { RevenueAnalyticsTab } from './state';

/** Query-string key carrying the shown Revenue Analytics grouping; absent for the default Providers tab. */
export const REVENUE_ANALYTICS_TAB_PARAM = 'tab';

/** The tab a location `search` string selects; anything but `symbols` or `firms` (including absence) is the default. */
export function parseRevenueAnalyticsTab(search: string): RevenueAnalyticsTab {
    const tab = new URLSearchParams(search).get(REVENUE_ANALYTICS_TAB_PARAM);
    return tab === 'symbols' || tab === 'firms' ? tab : 'providers';
}

/**
 * `search` with the tab param replaced by `tab`, other params untouched.
 * The default tab is carried by absence so plain links stay clean; the
 * parser reads both the same way, so the two functions are inverse. Empty
 * when nothing remains, `?`-prefixed otherwise, so it can be handed
 * straight to a navigation target.
 */
export function withRevenueAnalyticsTab(search: string, tab: RevenueAnalyticsTab): string {
    const params = new URLSearchParams(search);
    params.delete(REVENUE_ANALYTICS_TAB_PARAM);
    if (tab !== 'providers') params.set(REVENUE_ANALYTICS_TAB_PARAM, tab);
    return params.size === 0 ? '' : `?${params.toString()}`;
}
